// Memory only: never reuse responses across login sessions or permission changes.
const entries = new Map();
let currentScope;

export function getReadScope() {
  const token = localStorage.getItem('token') || '';
  let user = {};
  try { user = JSON.parse(localStorage.getItem('userInfo') || '{}') || {}; } catch (_) {}
  const identity = Object.keys(user).filter((key) => key !== 'queryModelId').sort()
    .map((key) => [key, user[key]]);
  return JSON.stringify([token, identity]);
}

export function invalidateSharedReads(path) {
  if (path) entries.delete(path);
  else entries.clear();
}

export function invalidateSharedReadsWithPrefix(prefix) {
  for (const path of entries.keys()) {
    if (path.startsWith(prefix)) entries.delete(path);
  }
}

export function sharedRead(path, loader, ttlMs, scope = getReadScope()) {
  if (scope !== currentScope) {
    entries.clear();
    currentScope = scope;
  }
  const existing = entries.get(path);
  if (existing?.promise) return existing.promise;
  if (existing && existing.expiresAt > Date.now()) return Promise.resolve(existing.response);

  const entry = {};
  entries.set(path, entry);
  entry.promise = Promise.resolve().then(loader).then((response) => {
    // A mutation/logout may have invalidated this request while it was in flight.
    if (entries.get(path) === entry && currentScope === scope) {
      if (Number(response?.data?.code) === 200) {
        entry.response = response;
        entry.expiresAt = Date.now() + ttlMs;
        delete entry.promise;
      } else entries.delete(path);
    }
    return response;
  }, (error) => {
    if (entries.get(path) === entry) entries.delete(path);
    throw error;
  });
  return entry.promise;
}

window.addEventListener('auth:logout', () => invalidateSharedReads());
window.addEventListener('storage', (event) => {
  if (event.key === 'token' || event.key === 'userInfo' || event.key === null) invalidateSharedReads();
});
